var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextboxRecomend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4165 16.5832V3.83317C1.4165 3.44359 1.55522 3.11008 1.83265 2.83265C2.11008 2.55522 2.44359 2.4165 2.83317 2.4165H14.1665C14.5561 2.4165 14.8896 2.55522 15.167 2.83265C15.4445 3.11008 15.5832 3.44359 15.5832 3.83317V12.3332C15.5832 12.7228 15.4445 13.0563 15.167 13.3337C14.8896 13.6111 14.5561 13.7498 14.1665 13.7498H4.24984L1.4165 16.5832ZM3.64775 12.3332H14.1665V3.83317H2.83317V13.13L3.64775 12.3332Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7H12M5 10H12",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16,0) scale(0.16667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextboxRecomend);
export default __webpack_public_path__ + "static/media/textbox-recomend.c31c8c7250641efa29a1a79cc8f30354.svg";
export { ForwardRef as ReactComponent };